import { AppTextField } from '../../components/AppTextField';
import { CRUDType } from '../../types/crud.type';
import EditFormComponent from '../common/EditFormComponent';
import { AppFileUploadField } from '../../components/AppFileUploadField';
import { MovementTvLayoutType, MovementType } from '../../types/movement.type';
import { MovementsServices } from '../../services/movements.service';
import { ValidationUtils } from '../../utils/validations.utils';
import MovementStationsAssociationField, { MovementStationsAssociationFieldProps } from './MovementStationsAssociationField';
import { AppAutocompleteField } from '../../components/AppAutocompleteField';

export function MovementEdit({ mode }: CRUDType) {
    return (
        <EditFormComponent<MovementType>
            title="Movement"
            mode={mode}
            backPath="/movements"
            service={{
                getById: MovementsServices.getById,
                add: MovementsServices.add,
                update: MovementsServices.update,
            }}
            transformPayload={(v => {
                const { movement_tv_layouts, ...rest } = v;
                return {
                    ...rest,
                    movement_tv_layouts: movement_tv_layouts?.map(v => ({
                        ...v,
                        layout_type: 'grid'
                    }))
                }
            })}
            formFields={[
                {
                    name: 'image',
                    component: AppFileUploadField,
                    props: {
                        rules: { required: 'Image is required' },
                        label: 'Choose Movement Image',
                    }
                },
                {
                    name: 'name',
                    component: AppTextField,
                    props: {
                        label: 'Name',
                        rules: {
                            required: 'Name is required'
                        },
                        columns: 4
                    }
                },
                {
                    name: 'pods',
                    component: AppTextField,
                    props: {
                        label: '# Bases',
                        rules: {
                            validate: ValidationUtils.isPositiveInteger
                        },
                        columns: 2
                    }
                },
                {
                    name: 'stations',
                    component: AppTextField,
                    props: {
                        label: '# Stations',
                        rules: {
                            validate: ValidationUtils.isPositiveInteger
                        },
                        columns: 2
                    }
                },
                {
                    /* Tvs configured as grid layouts */
                    name: 'movement_tv_layouts',
                    component: AppAutocompleteField,
                    props: {
                        columns: 4,
                        label: 'Select TVs with Grid Layout',
                        multiple: true,
                        valueProperty: 'tv_id',
                        // Map backend -> UI
                        getControlValue: (data: MovementTvLayoutType[]) =>
                            data?.filter(l => l.layout_type == 'grid')?.map((obj: any) => ({
                                id: obj.id,
                                tv_id: obj.tv_id
                            })),
                        // Map UI -> backend
                        transformValue: (value: any[]) =>
                            value?.map((tv) => ({
                                tv_id: tv.id,
                                layout_type: 'grid',
                            })) || [],
                        service: {
                            options: [
                                {
                                    id: 1,
                                    name: 'Tv 1'
                                }, {
                                    id: 2,
                                    name: 'Tv 2'
                                },
                                {
                                    id: 3,
                                    name: 'Tv 3'
                                }
                            ],
                        }
                    }
                },
                {
                    name: 'movement_station_pods',
                    component: MovementStationsAssociationField,
                    props: {
                        type: 'pods',
                    } as MovementStationsAssociationFieldProps
                },
                {
                    name: 'movement_station_tvs',
                    component: MovementStationsAssociationField,
                    props: {
                        type: 'tvs',
                    } as MovementStationsAssociationFieldProps
                }
            ]}
        />
    );

}